import { Box, Dialog, DialogContent, DialogProps } from '@mui/material'
import { FormProvider } from 'react-hook-form'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { EditModeProvider } from 'contexts/edit-mode.context'
import ActionButtons from '../action-buttons/action-buttons.component'
import DropAddressForm from '../forms/drop-address-form/drop-address-form.component'
import { useDropAddressForm } from '../forms/drop-address-form/drop-address-form.hooks'
import {
  buildDropAddress,
  DropAddressFormData,
} from '../drop-form-dialog/drop-form-dialog.utils'
import { updateEquipmentTaskAddress } from 'store/trips/trips.slice'

type EquipmentAddressDialogProps = {
  handleClose: () => void
  sequenceId: number | null
  initialAddress?: string
} & DialogProps

const EquipmentAddressDialog = ({
  open,
  handleClose,
  sequenceId,
  initialAddress = '',
}: EquipmentAddressDialogProps) => {
  const dispatch = useDispatch()
  const { formMethods } = useDropAddressForm()

  useEffect(() => {
    if (!open) return

    formMethods.reset({
      addressLine1: initialAddress,
      addressLine2: '',
      city: '',
      province: '',
      postalCode: '',
    })
  }, [formMethods, initialAddress, open])

  const handleDialogClose = () => {
    handleClose()
  }

  const handleSave = (data: DropAddressFormData) => {
    if (sequenceId == null) return

    dispatch(
      updateEquipmentTaskAddress({
        sequenceId,
        address: buildDropAddress(data),
      })
    )
    handleDialogClose()
  }

  return (
    <Dialog open={open} onClose={handleDialogClose} maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: 0 }}>
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(handleSave)}>
            <Box p={3}>
              <EditModeProvider initialEditMode suppressAutofill>
                <DropAddressForm />
              </EditModeProvider>
            </Box>

            <Box mt={2}>
              <ActionButtons
                firstBtnProps={{
                  title: 'Cancel',
                  onClick: handleDialogClose,
                  bgcolor: 'secondary.main',
                }}
                secondBtnProps={{
                  title: 'Save',
                  onClick: formMethods.handleSubmit(handleSave),
                }}
              />
            </Box>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  )
}

export default EquipmentAddressDialog
